import { render } from "./Team_adviser.vue?vue&type=template&id=50bc8ee3&scoped=true"
import script from "./Team_adviser.vue?vue&type=script&lang=js"
export * from "./Team_adviser.vue?vue&type=script&lang=js"

import "./Team_adviser.vue?vue&type=style&index=0&id=50bc8ee3&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-50bc8ee3"

export default script